import React from 'react';
import { cn } from '@/lib/utils';
import { LucideIcon } from 'lucide-react';

type IconCircleSize = 'sm' | 'md' | 'lg';
type IconCircleColor = 'primary' | 'secondary' | 'accent' | 'muted';

interface IconCircleProps extends React.HTMLAttributes<HTMLDivElement> {
  icon: LucideIcon;
  size?: IconCircleSize;
  color?: IconCircleColor;
}

const sizeMap: Record<IconCircleSize, { wrapper: string; icon: number }> = {
  sm: { wrapper: 'w-8 h-8', icon: 14 },
  md: { wrapper: 'w-10 h-10', icon: 18 },
  lg: { wrapper: 'w-12 h-12', icon: 22 },
};

const colorMap: Record<IconCircleColor, string> = {
  primary: 'bg-blue-100 text-blue-600',
  secondary: 'bg-emerald-100 text-emerald-600',
  accent: 'bg-amber-100 text-amber-600',
  muted: 'bg-gray-100 text-gray-600',
};

const IconCircle: React.FC<IconCircleProps> = ({
  icon: LIcon,
  size = 'md',
  color = 'primary',
  className,
  ...props
}) => {
  const { wrapper, icon } = sizeMap[size];
  return (
    <div
      className={cn(
        'flex items-center justify-center rounded-md flex-shrink-0',
        wrapper,
        colorMap[color],
        className
      )}
      {...props}
    >
      <LIcon size={icon} strokeWidth={2} />
    </div>
  );
};

export { IconCircle };
export type { IconCircleProps, IconCircleSize, IconCircleColor };
